/**
 * Set the primary and secondary font families by retrieving them from the beaver builder module designed to set them
 */
 export function setFontFamilyCSSVariables() {
    const fontPrimeOverrideSelector = document.querySelector(
      ".font-family-setter-primary"
    );
    const fontSecondOverrideSelector = document.querySelector(
      ".font-family-setter-secondary"
    );
    const html = document.querySelector("html");
  
    const fontFamilyPrimeOverride = getElementStyle(
      fontPrimeOverrideSelector,
      "font-family"
    );
    const fontFamilySecondOverride = getElementStyle(
      fontSecondOverrideSelector,
      "font-family"
    );
    const defaultPrimeFont = getElementStyle(html, "--font-family-primary");
    const defaultSecondaryFont = getElementStyle(html, "--font-family-secondary");
  
    if (
      fontFamilyPrimeOverride.split(" ").join("") !==
      defaultPrimeFont.split(" ").join("")
    ) {
      html.style.setProperty("--font-family-primary", fontFamilyPrimeOverride);
    }
    if (
      fontFamilySecondOverride.split(" ").join("") !==
      defaultSecondaryFont.split(" ").join("")
    ) {
      html.style.setProperty("--font-family-secondary", fontFamilySecondOverride);
    }
  }
  
  function getElementStyle(element, property) {
    if (element) {
      return window.getComputedStyle(element, null).getPropertyValue(property);
    } else {
      return "";
    }
  }